import { useFormContext, useController } from 'react-hook-form'
import Stack from '@mui/material/Stack'
import { SwitchLabeled } from '@ui/actions'
import { InfoTooltip } from '@ui/feedback'

interface Props {
  name: string
  label: string
  labelPlacement?: 'start' | 'end'
  'data-cy'?: string
  tooltip?: TooltipContents
}

const FormControlledSwitchLabeled = ({
  name,
  label,
  labelPlacement,
  'data-cy': dataCy,
  tooltip,
}: Props) => {
  const { control } = useFormContext()
  const { field } = useController({ name, control })

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <SwitchLabeled
        checked={field.value}
        onChange={field.onChange}
        label={label}
        labelPlacement={labelPlacement}
        data-cy={dataCy}
      />
      {tooltip && <InfoTooltip {...tooltip} />}
    </Stack>
  )
}

export default FormControlledSwitchLabeled
